import cardimg5 from "./Asset/portfolio/card-img-5.png";
import cardimg13 from "./Asset/portfolio/card-img-13.png";
import cardimg24 from "./Asset/portfolio/card-img-24.webp";
import cardimg32 from "./Asset/portfolio/card-img-32.png";
import cardimg33 from "./Asset/portfolio/card-img-33.png";
import cardimg34 from "./Asset/portfolio/card-img-34.webp";
import cardimg35 from "./Asset/portfolio/card-img-35.webp";
import cardimg37 from "./Asset/portfolio/card-img-37.webp";
import cardimg40 from "./Asset/portfolio/card-img-40.png";
import cardimg43 from "./Asset/portfolio/card-img-43.png";
import cardimg44 from "./Asset/portfolio/card-img-44.webp";
import cardimg47 from "./Asset/portfolio/bolly.jpg";
import cardlogo5 from "./Asset/portfolio/card-logo-5.svg";
import cardlogo13 from "./Asset/portfolio/card-logo-13.svg";
import cardlogo24 from "./Asset/portfolio/card-logo-24.svg";
import cardlogo32 from "./Asset/portfolio/card-logo-32.svg";
import cardlogo33 from "./Asset/portfolio/card-logo-33.svg";
import cardlogo34 from "./Asset/portfolio/card-logo-34.svg";
import cardlogo35 from "./Asset/portfolio/card-logo-35.svg";
import cardlogo37 from "./Asset/portfolio/card-logo-37.svg";
import cardlogo40 from "./Asset/portfolio/card-logo-40.svg";
import cardlogo43 from "./Asset/portfolio/card-logo-43.svg";
import cardlogo44 from "./Asset/portfolio/card-logo-44.png";
import cardlogo47 from "./Asset/portfolio/card-logo-48.svg";
import rightImg5 from "./Asset/portfolio/alpino-inner-1.png";
import rightImg13 from "./Asset/portfolio/vitawolf-inner-1.png";
import rightImg24 from "./Asset/portfolio/bethel-chambers-inner-1.webp";
import rightImg32 from "./Asset/portfolio/altavod-inner-1.png";
import rightImg33 from "./Asset/portfolio/movie-ranker-inner-1.webp";
import rightImg34 from "./Asset/portfolio/wishyoo-inner-1.png";
import rightImg35 from "./Asset/portfolio/algo-monster-inner-1.png";

import rightImg37 from "./Asset/portfolio/parcel-port-inner-1.webp";

import rightImg40 from "./Asset/portfolio/finfolio-inner-1.png";

import rightImg43 from "./Asset/portfolio/shiptime-scaled-inner-1.webp";
import rightImg44 from "./Asset/portfolio/paid-inner-1.png";

import rightImg47 from "./Asset/portfolio/Frame 7.png";
import slide2 from "./Asset/portfolio/paid-inner-2.png";
import slide4 from "./Asset/portfolio/alpino-inner-2.png";
import slide5 from "./Asset/portfolio/vitawolf-inner-2.webp";
import slide9 from "./Asset/portfolio/bethel-chambers-inner-2.webp";
import slide15 from "./Asset/portfolio/altavod-inner-2.webp";
import slide16 from "./Asset/portfolio/movie-ranker-inner-2.webp";
import slide17 from "./Asset/portfolio/wishyoo-inner-2.webp";
import slide18 from "./Asset/portfolio/algo-monster-inner-2.webp";
import slide20 from "./Asset/portfolio/parcel-port-inner-2.webp";
import slide23 from "./Asset/portfolio/finfolio-inner-2.webp";
import slide25 from "./Asset/portfolio/shiptime-scaled-inner-2.webp";
import slide28 from "./Asset/portfolio/bollywoodlehenga.png";
import ecom from "./Asset/portfolio/e-com.svg";
import d2c from "./Asset/portfolio/d2c.svg";
import aiIot from "./Asset/portfolio/ai&iot.svg";
import fitness from "./Asset/portfolio/fitness.svg";
import fintech from "./Asset/portfolio/fintech.svg";
import health from "./Asset/portfolio/health.svg";
import furniture from "./Asset/portfolio/furniture.svg";
import lerning from "./Asset/portfolio/lerning.svg";
import canada from "./Asset/portfolio/canada.svg";
import india from "./Asset/portfolio/india.svg";
import egypt from "./Asset/portfolio/ejipt.svg";
import australia from "./Asset/portfolio/ausralia.svg";
import south from "./Asset/portfolio/south-koriya.svg";
import phili from "./Asset/portfolio/philipins.svg";
import usa from "./Asset/portfolio/usa.svg";
import shri from "./Asset/portfolio/shrilanka.svg";
import uk from "./Asset/portfolio/uk.svg";
import germony from "./Asset/portfolio/germony.svg";
import uae from "./Asset/portfolio/UAE_Flag.svg";
import appDev from "./Asset/portfolio/app-development.svg";
import webDev from "./Asset/portfolio/web-development.svg";
import d2cecom from "./Asset/portfolio/d2c-ecom.svg";
import crypto from "./Asset/portfolio/crypto.svg";
import law from "./Asset/portfolio/law-service.svg";
import webMain from "./Asset/portfolio/web-maintan.svg";
import businesServic from "./Asset/portfolio/business-services.svg";
import management from "./Asset/portfolio/management.svg";
import pageMet from "./Asset/portfolio/page-speed.svg";
import webEnhance from "./Asset/portfolio/web-inhance.svg";
import serchEngine from "./Asset/portfolio/serch-engine.svg";
import entertainment from "./Asset/portfolio/entertainment.svg";
import enterprice from "./Asset/portfolio/enterprice.svg";
import logistic from "./Asset/portfolio/logistic.svg";
import fullStack from "./Asset/portfolio/full-stack.svg";
import backend from "./Asset/portfolio/backend.svg";
import uiux from "./Asset/portfolio/ui-ux-design.svg";
import node from "./Asset/portfolio/nodejs.svg";
import mongo from "./Asset/portfolio/mongodb.svg";
import react from "./Asset/portfolio/react-js.svg";
import java from "./Asset/portfolio/java.svg";
import wordpress from "./Asset/portfolio/wordpress-1.svg";
import shopify from "./Asset/portfolio/shopify-1.svg";
import python from "./Asset/portfolio/python.svg";
import angular from "./Asset/portfolio/angular.svg";
import disaster from "./Asset/portfolio/disaster.svg";
import invest from "./Asset/portfolio/investment.svg";
import amitej from "./Asset/portfolio/amitej-priyadarshi.png";
import forwardBot from "./Asset/portfolio/telegram.png";
import forwardbotLogo from "./Asset/portfolio/forwardbotLogo.png";
import forwardbotRight from "./Asset/portfolio/forwardbot-right.png";
import forwardSlider from "./Asset/portfolio/forwordBot_fullImage.png";
import ReactLogo from "./Asset/portfolio/reactJs_logo.png";
import ADSSPY from "./Asset/portfolio/ADSPAY.png";
import ADSSPYRightImage from "./Asset/portfolio/ADSPAY-rightImage.png";
import ADSSPYLogo from "./Asset/portfolio/ADSSPY_logo.png";
import ADSSPYSlider from "./Asset/portfolio/ADSPAY-fullImage.png";
import OlaPassSlider from "./Asset/portfolio/Olapass-fullImage.png";
import SnappassLogo from "./Asset/portfolio/snappass-icon.png";
import SnappassSummaryImage from "./Asset/portfolio/Snappass-Book-Event-Tickets.png";
import SnappassHeroImage from "./Asset/portfolio/Snappass-Book-hero-section.png";
import SnappassCoverImage from "./Asset/portfolio/Snappass-cover.png";
import Malkaya from "./Asset/portfolio/Malkaya.png";
import MalkayaRightImg from "./Asset/portfolio/Malkaya-RightImage.png";
import MalkayaSlider from "./Asset/portfolio/Malkaya-fullImage.png";
import MalkayaLogo from "./Asset/portfolio/malkayaLogo.png";
import PratikClient from "./Asset/portfolio/pratik_client.png";
import MehulClient from "./Asset/portfolio/mehul_client.png";
import VEYNOUImage from "./Asset/portfolio/VEYNOU-Jewelry.png";
import VEYNOUImageRight from "./Asset/portfolio/VEYNOU-Jewelry-Right.png";
import veynouSlider from "./Asset/portfolio/VEYNOU-Jewelry-FullPage.png";
import veynouLogo from "./Asset/portfolio/veynouLogo.png";
import beautifulearthboutique from "./Asset/portfolio/Beautiful-Earth-Boutique-.png";
import beautifulRight from "./Asset/portfolio/Beautiful-Earth-Boutique-right.png";
import beautifulSlider from "./Asset/portfolio/Beautiful-Earth-Boutique-full.png";
import beautifuLogo from "./Asset/portfolio/beautifuLogo.png";
import oudDubai from "./Asset/portfolio/Oud-Arabia-Dubai.png";
import oudDubaiLogo from "./Asset/portfolio/oudDubaiLogo.png";
import oudDubaiRight from "./Asset/portfolio/Oud-Arabia-Dubai-right.png";
import oudDubaiSlider from "./Asset/portfolio/Oud-Arabia-Dubai-fullPage.png";
import PrepDaily from "./Asset/portfolio/PrEP-Daily.png";
import PrepDailyLogo from "./Asset/portfolio/PrepDailyLogo.png";
import PrepDailyRight from "./Asset/portfolio/PrEP-Daily-right.png";
import PrepDailyFull from "./Asset/portfolio/PrEP-Daily-fullPage.png";
import muskaRain from "./Asset/portfolio/Muskoka-Rain.png";
import muskaRainLogo from "./Asset/portfolio/muskaRainLogo.png";
import muskaRainRight from "./Asset/portfolio/Muskoka-Rain-right.png";
import muskaRainFull from "./Asset/portfolio/Muskoka-Rain-fullPage.png";
import muskokaLake from "./Asset/portfolio/Muskoka-Lakes.png";
import muskokaLakeLogo from "./Asset/portfolio/muskokaLakeLogo.png";
import muskokaLakeRight from "./Asset/portfolio/Muskoka-Lakes-Right.png";
import muskokaLakeFullPage from "./Asset/portfolio/Muskoka-Lakes-fullPage.png";
import fitnessVita from "./Asset/portfolio/Home-Vita-Fitness.png";
import fitnessVitaLogo from "./Asset/portfolio/fitnessVitaLogo.png";
import fitnessVitaRight from "./Asset/portfolio/Home-Vita-Fitness-right.png";
import fitnessVitaFull from "./Asset/portfolio/Home-Vita-Fitness-fullPage.png";
import Pediatric from "./Asset/portfolio/Pediatric-Dentist.png";
import PediatricLogo from "./Asset/portfolio/PediatricLogo.png";
import PediatricRight from "./Asset/portfolio/Pediatric-Dentist-right.png";
import PediatricFull from "./Asset/portfolio/Pediatric-Dentist-fullPage.png";
import NerdCandy from "./Asset/portfolio/NERDS-Candy.png";
import NerdCandyLogo from "./Asset/portfolio/NerdCandyLogo.png";
import NerdCandyRight from "./Asset/portfolio/NERDS-Candy-right.png";
import NerdCandyFull from "./Asset/portfolio/NERDS-Candy-fullImage.png";
import windowReplace from "./Asset/portfolio/Windows-Replacement.png";
import windowReplaceLogo from "./Asset/portfolio/windowReplaceLogo.png";
import windowReplaceRight from "./Asset/portfolio/Windows-Replacement-right.png";
import windowReplaceFull from "./Asset/portfolio/Windows-Replacement-fullImage.png";
import Birmingham from "./Asset/portfolio/Birmingham-Law.png";
import BirminghamLogo from "./Asset/portfolio/BirminghamLogo.png";
import BirminghamRight from "./Asset/portfolio/Birmingham-Law-right.png";
import BirminghamFull from "./Asset/portfolio/Birmingham-Law-full.png";
import sellPhone from "./Asset/portfolio/Sell-Your-Phone.png";
import sellPhoneLogo from "./Asset/portfolio/sellPhoneLogo.png";
import sellPhoneRight from "./Asset/portfolio/Sell-Your-Phone-right.png";
import sellPhoneFull from "./Asset/portfolio/Sell-Your-Phone-full.png";
import findCare from "./Asset/portfolio/Find-Care.png";
import findCareLogo from "./Asset/portfolio/findCareLogo.png";
import findCareRight from "./Asset/portfolio/Find-Care-right.png";
import findCareFull from "./Asset/portfolio/Find-Care-full.png";
import Spotlight from "./Asset/portfolio/Spotlight-Indianapolis.png";
import SpotlightLogo from "./Asset/portfolio/SpotlightLogo.png";
import SpotlightRight from "./Asset/portfolio/Spotlight-Indianapolis-right.png";
import Spotlightfull from "./Asset/portfolio/Spotlight-Indianapolis-full.png";

const portfolioData = [
  {
    imgSrc: forwardBot,
    link: "https://www.forwardbot.in",
    logoSrc: forwardbotLogo,
    rightImg: forwardbotRight,
    slideImg: forwardSlider,
    title: "Forward Bot",
    category: "Smart Telegram Message Forwarding Tool",
    industry: [
      { name: "Smart Telegram Message Forwarding Tool", industryImg: ecom },
    ],
    country: [{ name: "India", countryImg: india }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "React JS", technologieImg: ReactLogo }],
    description:
      "A real-time system that automatically forwards Telegram messages between channels and groups with precision and reliability.",
    paragraphs: [
      "This project is a Telegram message forwarding solution designed to automate the transfer of messages from one channel or group to multiple destinations. It supports real-time forwarding, message filtering, and seamless integration using the Telegram Bot API. The system is built to reduce manual effort, improve information distribution, and ensure fast, accurate message delivery. Ideal for businesses, content creators, and community managers who need efficient communication workflows.",
    ],
    challenges: {
      intro:
        "Initially, the Telegram Message Forwarding project faced multiple challenges while building a reliable and efficient automation system:",
      points: [
        "To ensure real-time message forwarding without delays or data loss.",
        "To handle multiple Telegram channels and groups securely.",
        "To manage Telegram API rate limits and prevent message failures.",
        "To design a scalable system capable of handling high message volumes.",
        "To maintain accuracy while forwarding messages across different destinations.",
      ],
    },
    deliverables: {
      intro:
        "All the challenges were carefully addressed, and the project successfully delivered the following outcomes:",
      points: [
        "'Message forwarding system:'A reliable automation setup that forwards messages instantly between Telegram channels and groups.",
        "API integration :'Secure and optimized integration with the Telegram Bot API.",
        "'Filtering logic:' Smart message handling to forward only relevant or selected content.",
        "'Scalability:'A robust architecture capable of handling large-scale message traffic.",
        "'Performance optimization :'Ensured fast, stable, and error-free message delivery.",
      ],
    },
    conclusions: {
      info: [
        "The Telegram Message Forwarding system was successfully implemented and received positive feedback for its reliability and efficiency. Users appreciated the automation, real-time message delivery, and reduced manual effort.",
        "The project effectively streamlined communication by enabling seamless message distribution across multiple Telegram channels and groups. Its scalable design and optimized performance make it suitable for businesses, content creators, and community managers.",
        "Overall, the Telegram Message Forwarding project achieved its goal of simplifying Telegram communication workflows through secure, fast, and intelligent automation.",
      ],
    },
    clientInfo: {
      clientImg: PratikClient,
      clientName: "Pratik Zala",
      clientPosition: "Founder of The Blessed Ones",
      review:
        "Thank you, Codeffi LLP, We were looking for a reliable solution to forward messages across multiple Telegram groups and channels without manual effort, and this platform exceeded our expectations. The automation works flawlessly in real time, ensuring every message is delivered accurately and without delays.",
    },
  },
  {
    imgSrc: ADSSPY,
    link: "https://www.adyhub.in",
    logoSrc: ADSSPYLogo,
    rightImg: ADSSPYRightImage,
    slideImg: ADSSPYSlider,
    title: "ADSSPY",
    category: "All-in-One AI Marketing & Content Creation ",
    industry: [
      {
        name: "All-in-One AI Marketing & Content Creation Website",
        industryImg: ecom,
      },
    ],
    country: [{ name: "India", countryImg: india }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "React JS", technologieImg: ReactLogo }],
    description:
      "An AI-powered platform that generates high-converting ad copies, social media content, multimedia assets, and marketing creatives across multiple platforms.",
    paragraphs: [
      "This AI Content Generator website is designed to simplify and automate digital content creation for marketers, businesses, and creators. The platform supports Google Ad headlines and descriptions, Facebook ad copy, Instagram captions, YouTube titles and descriptions, Text-to-Speech conversion, and AI-based image generation. With a clean interface and powerful AI engine, users can create high-quality, platform-optimized content in seconds, improving productivity and marketing performance.",
    ],
    challenges: {
      intro:
        "Initially, the AI Content Generator website faced multiple challenges while building a versatile and scalable content creation platform:",
      points: [
        "To support diverse content formats across advertising and social media platforms.",
        "To ensure high-quality, engaging, and conversion-focused AI-generated content.",
        "To integrate Text-to-Speech and Image Generation smoothly.",
        "To design an intuitive UI suitable for both beginners and professionals.",
        "To maintain fast performance and scalability under heavy usage.",
      ],
    },
    deliverables: {
      intro:
        "All challenges were effectively addressed, and the following deliverables were successfully implemented:",
      points: [
        "'Google Ads Generator:'AI-driven headlines and descriptions optimized for conversions.",
        "Facebook Ad Copy:'High-performing ad headlines and descriptions.",
        "'Instagram Captions:'Creative and hashtag-optimized captions for better reach.",
        "'YouTube Titles & Descriptions:SEO-friendly video metadata generation.",
        "'Text-to-Speech:'Natural-sounding voice generation from text.",
        "'Image Generator:'AI-powered image creation for ads and social media",
        "'Responsive Design:'Fully optimized for desktop and mobile devices.",
        "'Performance Optimization:'Fast, reliable, and scalable content generation.",
      ],
    },
    conclusions: {
      info: [
        "The AI Content Generator website delivered a complete solution for modern digital marketing needs. Users appreciated the ability to generate multiple types of content from a single platform, saving time and effort.",
        "By combining ad copy generation, social media content, multimedia tools, and AI automation, the platform successfully enhanced content quality and marketing efficiency. The project stands as a powerful example of how AI can transform content creation workflows for businesses and creators alike.",
      ],
    },
    clientInfo: {
      clientImg: MehulClient,
      clientName: "Mehul Patel",
      clientPosition: "Founder of The Blessed Ones",
      review:
        "Thank you, Codeffi LLP, The quality of AI-generated content is impressive and perfectly optimized for each platform. Features like Text-to-Speech and Image Generation have added immense value to our marketing workflow. The interface is clean, fast, and extremely user-friendly.",
    },
  },
  {
    imgSrc: SnappassCoverImage,
    link: "https://www.snappass.in",
    logoSrc: SnappassLogo,
    rightImg: SnappassHeroImage,
    slideImg: SnappassSummaryImage,
    title: "Snappass",
    category: "Online Event Ticket Purchase & Management ",
    industry: [
      {
        name: "Online Event Ticket Purchase & Management Website",
        industryImg: ecom,
      },
    ],
    country: [{ name: "India", countryImg: india }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "React JS", technologieImg: ReactLogo }],
    description:
      "Snappass is a secure and user-friendly event ticketing and digital pass management platform that allows organizers to issue tickets and attendees to browse and manage their events — developed by Codeffi.",
    paragraphs: [
      "This Event Ticket Booking website is designed to provide a seamless experience for users to discover events and purchase tickets online. The platform supports multiple event categories, real-time ticket availability, and secure online payments. With a modern interface and optimized performance, users can easily select events, choose ticket types, and complete purchases in just a few steps, making event access fast and convenient.",
    ],
    challenges: {
      intro:
        "Initially, the Event Ticket Booking website faced several challenges while building a reliable and scalable ticketing solution:",
      points: [
        "To manage real-time ticket availability and prevent overbooking.",
        "To implement secure and smooth payment processing.",
        "To design an intuitive booking flow for all user types.",
        "To support multiple event types such as concerts, conferences, and workshops.",
        "To ensure mobile and desktop responsiveness.",
        "To maintain performance during high traffic and peak booking times.",
      ],
    },
    deliverables: {
      intro:
        "All challenges were successfully addressed, and the following deliverables were implemented:",
      points: [
        "'Event Listing System:'Dynamic event listings with detailed information.",
        "Ticket Purchase Flow:'Smooth and secure ticket selection and checkout process.",
        "'Payment Integration:'Safe and reliable online payment gateways.",
        "'Ticket Management:Digital ticket generation and purchase confirmation.",
        "'User Experience:'Clean, responsive, and easy-to-use interface.",
        "'Performance Optimization:'Fast loading and scalable infrastructure.",
        "'Responsive Design:'Fully optimized for desktop and mobile devices.",
        "'Security': Secure handling of user data and transactions.",
      ],
    },
    conclusions: {
      info: [
        "The Event Ticket Booking platform successfully delivered a seamless and reliable solution for purchasing event tickets online. Users appreciated the easy booking process, secure payments, and clear event information.",
        "The platform effectively simplified event access for users while providing organizers with a dependable ticket sales system. Its scalability and performance make it suitable for handling both small and large-scale events.",
        "Overall, the project stands as a robust digital ticketing solution that enhances the event booking experience through convenience, security, and efficiency.",
      ],
    },
    clientInfo: {
      clientImg: amitej,
      clientName: "Keval Savani",
      clientPosition: "Founder of The Blessed Ones",
      review:
        "Thank you, Codeffi LLP,We needed a solution that could handle online ticket sales efficiently while providing a simple and secure booking flow. This platform exceeded our expectations with its clean design, real-time ticket availability, and seamless payment process.",
    },
  },
  {
    imgSrc: Malkaya,
    link: "https://malkaya.com",
    logoSrc: MalkayaLogo,
    rightImg: MalkayaRightImg,
    slideImg: MalkayaSlider,
    title: "Malkaya",
    category: "E-Commerce",
    industry: [{ name: "E-Commerce", industryImg: ecom }],
    country: [{ name: "India", countryImg: india }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "Shopify", technologieImg: shopify }],
    description:
      "A modern e-commerce platform that allows users to explore and purchase authentic traditional kurtas with a seamless online shopping experience.",
    paragraphs: [
      "This Traditional Kurta e-commerce website is designed to showcase and sell a wide range of ethnic kurtas while preserving cultural elegance. The platform provides detailed product listings, high-quality images, size selection, and a smooth checkout process. With secure payments and responsive design, users can enjoy a convenient and trustworthy shopping experience across all devices.",
    ],
    challenges: {
      intro:
        "Initially, the Traditional Kurta e-commerce project faced several challenges while building a culturally rich yet modern online store:",
      points: [
        "To present traditional designs in a visually appealing and premium manner.",
        "To manage product variations such as size, color, and fabric.",
        "To implement secure and user-friendly online payment options.",
        "To ensure fast loading and mobile responsiveness.",
        "To build trust through a smooth and reliable checkout experience.",
      ],
    },
    deliverables: {
      intro:
        "All challenges were successfully addressed, and the following deliverables were implemented:",
      points: [
        "'Product Catalog:'Well-organized kurta listings with detailed descriptions and images.",
        "'Product Variations:'Size, color, and fabric selection for each kurta.",
        "'Shopping Cart & Checkout :'Smooth and secure purchasing workflow.",
        "'Responsive Design:'Optimized for desktop, tablet, and mobile devices..",
        "'Order Management:'Clear order summary and confirmation process.",
        "'Performance Optimization:'Fast and stable browsing experience.",
      ],
    },
    conclusions: {
      info: [
        "The Traditional Kurta e-commerce website successfully delivered an elegant and reliable online shopping experience. Customers appreciated the cultural presentation, ease of navigation, and secure payment process.",
        "The platform effectively brought traditional ethnic wear to the digital space, making authentic kurtas easily accessible to a wider audience. By combining cultural aesthetics with modern e-commerce functionality, the project achieved its goal of offering tradition with convenience.",
      ],
    },
    clientInfo: {
      clientImg: amitej,
      clientName: "Rajesh Kumar",
      clientPosition: "Founder of The Blessed Ones",
      review:
        "Thank you, Codeffi LLP, We wanted an online store that truly represents the richness of traditional kurtas while offering modern e-commerce functionality. This platform delivered exactly that. The product presentation, clean design, and easy navigation made it simple for customers to explore and purchase kurtas with confidence.",
    },
  },
  {
    imgSrc: cardimg47,
    link: "https://bollywoodlehenga.com",
    logoSrc: cardlogo47,
    rightImg: rightImg47,
    slideImg: slide28,
    title: "Bollywood Lehengha",
    category: "E-Commerce",
    industry: [{ name: "E-Commerce", industryImg: ecom }],
    country: [{ name: "India", countryImg: india }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "Shopify", technologieImg: shopify }],
    description:
      "Bollywood Lehengha is an Ecommerce platform offering a stunning collection of traditional and modern lehengas.",
    paragraphs: [
      "Bollywood Lehengha is dedicated to bringing the beauty and elegance of Bollywood fashion to customers worldwide. With a focus on quality craftsmanship, the platform curates lehengas that embody the rich cultural heritage of India while adding a contemporary twist.",
      "The platform is powered by Shopify, ensuring a seamless and user-friendly shopping experience. Customers can explore an extensive catalog, enjoy secure payment options, and receive worldwide shipping to make their special occasions even more memorable.",
    ],
    challenges: {
      intro:
        "Initially, Bollywood Lehengha faced multiple challenges while creating a compelling e-commerce platform:",
      points: [
        "To create an 'intuitive and visually stunning website' that appeals to a global audience.",
        "To implement 'secure and efficient payment integrations' for seamless transactions.",
        "To ensure the platform is optimized for both desktop and mobile devices.",
        "To integrate reliable 'worldwide shipping solutions'.",
        "To reflect the rich cultural heritage of India while maintaining a 'modern aesthetic'.",
      ],
    },
    deliverables: {
      intro:
        "All the challenges were meticulously addressed, and our team provided the following deliverables:",
      points: [
        "'Front end :' A responsive and visually appealing user interface that reflects Bollywood's elegance.",
        "'Back end :' A robust and scalable architecture powered by Shopify for seamless operations.",
        "'Payment integration :' Secure and user-friendly payment gateways to facilitate global transactions.",
        "'Shipping integration :' Reliable worldwide shipping functionality with real-time tracking.",
        "'Optimization :' Ensured cross-platform responsiveness for desktop and mobile users.",
      ],
    },
    conclusions: {
      info: [
        "The launch of Bollywood Lehengha was met with an overwhelmingly positive response from customers globally. Users appreciated the platform's elegant design, extensive product catalog, and seamless shopping experience.",
        "The e-commerce platform successfully bridged the gap between traditional Indian fashion and modern online shopping, making it accessible to a worldwide audience. Customers commended the ease of browsing, secure payment options, and reliable shipping services.",
        "The successful implementation of Bollywood Lehengha has established it as a go-to destination for Bollywood-inspired lehengas, fulfilling its mission of delivering cultural elegance with modern convenience.",
      ],
    },
    clientInfo: {
      clientImg: amitej,
      clientName: "Amitej Priyadarshi",
      clientPosition: "Founder of The Blessed Ones",
      review:
        "Thank you, Codeffi LLP, for your dedication in developing a solution that truly serves the special needs community. While it’s easier to create solutions for the neurotypical world, building one for the neurodiverse world is a challenge and you nailed it. We at The Blessed Ones are proud to be on this ourney together.",
    },
  },
  {
    imgSrc: cardimg44,
    logoSrc: cardlogo44,
    link: "https://paid.com",
    rightImg: rightImg44,
    slideImg: slide2,
    title: "Paid Inc.",
    category: "Fintech",
    industry: [
      { name: "E-commerce", industryImg: ecom },
      { name: "Fintech", industryImg: fintech },
    ],
    country: [{ name: "Canada", countryImg: canada }],
    services: [
      { name: "App Development", servicesImg: appDev },
      { name: "Web Development", servicesImg: webDev },
      { name: "UI/UX Design", servicesImg: uiux },
    ],
    technologies: [{ name: "WordPress", technologieImg: wordpress }],
    description:
      "Paid is a B2B Ultimate Business solution and payment platform for business owners.",
    paragraphs: [
      "Our client initially hired us to tackle front-end and UI/UX for their B2B platform. They were impressed by our dedication and entrusted us with expanding the project to mobile and web solutions. Eight years of collaboration resulted in several major features. A few of them are ‘Paid Web + Cart’ for site customization, ‘Paid Payment’ for flexible payments, and ‘Paid Shipping’ for efficient goods delivery. This advanced project was successfully executed by Codeffi digital inventors within record time.",
      "Paid vision is to create a platform that helps businesses that work with Omni channel platforms for complete business solutions.",
    ],
    challenges: {
      intro:
        "Initially, Paid cart was the only service available and the Challenges faced were:",
      points: [
        "To get faster 'payment integration' for users.",
        "To create a 'centralized platform' for business solutions.",
        "To create a Mobile Application.",
        "Implementation of physical card acceptance at their 'POS transaction'.",
      ],
    },
    deliverables: {
      intro:
        "All the challenges were addressed by our team and we assisted them in creating a connection of services. Here’s what we delivered:",
      points: [
        "Front end – An easy-to-interact user experience.",
        "Back end – Design and architect the entire project.",
        "Mobile App – Developed mobile application using React Native.",
        "POS – Card reader supports Wi-Fi & Bluetooth Tech.",
        "Server Management – Google console integration.",
      ],
    },
    conclusions: {
      intro:
        "In the end, the Codeffi team delivered an impeccable job exceeding the client’s expectations.",
      points: [
        "'Project Journey:' Our commitment and quality work earned us complete project control. We crafted a user-friendly, sustained, and visually appealing interface for Paid, a versatile B2B business solution.",
        "'Revolutionizing POS:' Paid’s mobile app redefines Point of Sale transactions, offering efficiency and security. It empowers businesses to modernize payment experiences while streamlining operations.",
        "'Simplify Invoicing:' Paid Invoices app transforms financial management. Create, send, and track invoices effortlessly, automate recurring bills, and enhance cash flow predictability. Boost efficiency and thrive in a dynamic business landscape.",
      ],
    },
  },

  {
    imgSrc: cardimg5,
    logoSrc: cardlogo5,
    rightImg: rightImg5,
    slideImg: slide4,
    title: "Alpino Health Foods",
    link: "https://alpino.store",
    category: "D2C",
    industry: [{ name: "D2C", industryImg: d2c }],
    country: [{ name: "India", countryImg: india }],
    services: [
      { name: "Web Development", servicesImg: webDev },
      { name: "UI/UX Design", servicesImg: uiux },
      { name: "Web Manitenance", servicesImg: webMain },
    ],
    technologies: [{ name: "Shopify", technologieImg: shopify }],
    description:
      "Alpino is a pioneering D2C brand from Surat, Gujarat, renowned across the nation for its high-quality peanut butter and other peanut-based products.",
    paragraphs: [
      "Alpino is a pioneering D2C brand from Surat, Gujarat, renowned across the nation for its high-quality peanut butter and other peanut-based products. As one of the first few brands from Surat to gain pan-India recognition, Alpino is on a mission to make India fall in love with peanuts. They transform good quality peanuts into delicious and nutritious foods that provide essential protein. By doing so, Alpino is not only enhancing the dietary habits of their customers but also contributing to a healthier lifestyle for the nation. Their products are a favorite among bodybuilders and national-level athletes. Alpino also garnered national attention by presenting their products on Shark Tank India, Season 1. Their innovative approach and dedication to quality were appreciated by all the sharks. Through their efforts, Alpino is not only providing top-notch health foods but also raising awareness and driving positive change in the fitness community.”",
    ],
    challenges: {
      info: [
        "Alpino, while being a beloved brand for peanut-based health foods, faced significant challenges in retaining customers. They recognized the need to deepen their engagement with customers and encourage repeat visits to their website. Soon they realised that that social media ads alone were not generating the desired outcomes. The ads demanded high expenditure for higher sales, and their sales funnel resembled a leaky bucket, with potential customers slipping away before making repeat purchases.",
        "Alpino wanted a long-term and sustainable solution that could fix the leaky bucket in their sales funnel, encourage repeat visits to their website and improve overall customer engagement.",
      ],
    },
    deliverables: {
      info: [
        "After thoroughly understanding Alpino’s needs, we crafted a tailored solution to help Alpino achieve their objectives. We recommended launching an exclusive membership program with a range of enticing benefits: free gifts, loyalty points, birthday treats, free shipping, and more. The idea was simple: the more customers shopped, the more rewards they received.",
        "The program was so enticing that more and more customers wanted to become Alpino members. For regular peanut butter eaters and fitness-freaks, joining was a no-brainer. This strategic membership program also encouraged customers to return to Alpino’s website repeatedly. The program was designed to cultivate customer loyalty, encouraging every member to make 3-6 purchases within the next year. By providing great rewards, Alpino fixed their leaky bucket, ensuring that customers kept coming back.",
        "The program delighted customers with free gifts and birthday treats, that significantly boosted engagement. Customers enjoyed earning points and looked forward to redeeming them for future purchases, which strengthened their loyalty to the brand.",
        "Codeffi had the privilege to execute this program end-to-end for Alpino, from ideation to implementation. Collaborating with Alpino’s brilliant founders, who are both young and visionary, was an inspiring journey. Their forward-thinking mindset and enthusiasm fueled the project’s success.",
      ],
    },
    conclusions: {
      info: [
        "Now, along with the great peanut-based products, Alpino also has a great membership program that is loved by their members.",
        "The membership program significantly increased customer loyalty, as members eagerly returned 3-6 times throughout the year to earn and redeem rewards. This consistent engagement translated into substantial revenue growth, with the membership program generating 30,00,000 INR within the first year of its launch.",
        "Members were delighted with the free gifts and other rewards, which not only enhanced their shopping experience but also encouraged them to spread the word. Many customers recommended the program to their friends, further expanding Alpino’s loyal customer base. The sense of community and the continuous incentives kept customers excited and invested in the brand.",
        "The success of the program not only solidified their existing customer base but also attracted new members, creating a dedicated and enthusiastic community of peanut butter lovers.",
      ],
    },
  },
  {
    imgSrc: cardimg13,
    logoSrc: cardlogo13,
    rightImg: rightImg13,
    slideImg: slide5,
    title: "VitaWolf",
    link: "https://vitawolf.in",
    category: "D2C",
    industry: [{ name: "E-Commerce", industryImg: ecom }],
    country: [{ name: "India", countryImg: india }],
    services: [
      { name: "Page Speed Metrics", servicesImg: pageMet },
      { name: "Website Enhancement", servicesImg: webEnhance },
      { name: "Search Engine Optimisation", servicesImg: serchEngine },
      { name: "Web Maintenance", servicesImg: webMain },
    ],
    technologies: [{ name: "React", technologieImg: react }],
    paragraphs: [
      "Vita Wolf offers cutting-edge gym wear exclusively designed for the modern women, that seamlessly blends fashion and functionality. Founded by Shubham Agrawal, Vita Wolf’s mission is to empower women to unleash their inner strength and confidence through high-quality, stylish gym wear. Vita Wolf’s innovative and performance-driven apparel aims to support women in achieving their fitness goals while feeling empowered and confident every step of the way.",
    ],
    description:
      "Vitawolf offers comfortable and stylish workout apparel that transcends conventional boundaries exclusively designed for the modern she-wolf.",
    challenges: {
      info: [
        "Amitej recognized the unique challenges faced by specially-abled children and their families, and was commited to make a difference. His goal was to create a platform that would transcend geographical boundaries, ensuring that every child, regardless of their location, could access the specialized education and support they deserve.",
        "This project was not just about building a digital platform; it was about empowering families, providing hope, and creating opportunities for a brighter future for every child associated with The Blessed Ones.",
      ],
    },
    deliverables: {
      info: [
        "Vita Wolf aimed to improve their website’s overall performance and provide a better shopping experience for their customers. Their main challenge was the slow load speed of their website, which was due to being heavy with images. They needed a solution to optimize the website and enhance the user experience. By addressing these issues, Vita Wolf sought to ensure that customers could easily navigate the site, enjoy a seamless shopping experience, and feel more satisfied with their overall interaction with the brand. Improving website speed was crucial to retaining customers and boosting overall satisfaction.",
      ],
      points: [
        "'Optimizing page speed' to ensure faster load times.",
        "'Improving mobile responsiveness' so that the site performs seamlessly across all devices.",
        "Setting up condition-based shipping to 'streamline the checkout process.'",
        "Resolving issues with order placement to 'make the shopping experience smoother.'",
      ],
    },
    conclusions: {
      info: [
        "The improved website now allows users to interact almost immediately after it loads. These optimizations have significantly improved customer satisfaction and shopping experience.",
        "The impact of these improvements was significant and achieved within just one month. The key results include:",
      ],
      points: [
        "'Website Performance :' Before Codeffi’s intervention, Vita Wolf’s website performance was at 45%. After our enhancements, it soared to an impressive 99%.",
        "'Page Loading Speed :' The Total Blocking Time (TBT) was drastically reduced from 425 milliseconds to just 10 milliseconds.",
        "'Website Structure :' The website structure was improved from 62% to 76%.",
        "'User Experience :' These enhancements led to a much faster, smoother, and more enjoyable shopping experience for Vita Wolf’s customers, resulting in higher satisfaction and increased retention.",
        "'Website Traffic :' The improvements significantly increased the website traffic, bringing in more potential customers.",
      ],
    },
  },

  {
    imgSrc: cardimg24,
    link: "https://bethelchambers.com",
    logoSrc: cardlogo24,
    rightImg: rightImg24,
    slideImg: slide9,
    title: "Bethel Chambers",
    category: "Others",
    industry: [{ name: "Law service Provider", industryImg: law }],
    country: [{ name: "Philippines", countryImg: phili }],
    services: [
      { name: "Frontend Development", servicesImg: fullStack },
      { name: "UI/UX Design", servicesImg: uiux },
      { name: "web Development", servicesImg: webDev },
    ],
    technologies: [{ name: "WordPress", technologieImg: wordpress }],
    paragraphs: [
      "This website offers legal services, including Cross-border Probate, Probate & Estate Distribution, Adoption & Guardianship, Estate Planning & Wills, Matrimonial & Divorce, and Other Legal Matters.",
    ],
    description:
      "Bethel Chambers is a platform that offers a range of legal services.",
  },

  {
    imgSrc: cardimg32,
    link: "https://www.altavod.com",
    logoSrc: cardlogo32,
    rightImg: rightImg32,
    slideImg: slide15,
    title: "Altavod",
    category: "Entertainment",
    industry: [{ name: "Entertainment/Media", industryImg: entertainment }],
    country: [{ name: "USA", countryImg: usa }],
    services: [
      { name: "Web Development", servicesImg: webDev },
      { name: "Frontend Development", servicesImg: fullStack },
      { name: "UI/UX Design", servicesImg: uiux },
    ],
    technologies: [
      { name: "Angular", technologieImg: angular },
      { name: "Node", technologieImg: node },
      { name: "MongoDB", technologieImg: mongo },
    ],
    paragraphs: [
      "Altavod, an extension of our collaboration with a valued client from MovieRanker, reflects their trust in our dedication and impeccable work. Altavod, the resultant project, serves as a unique platform bridging filmmakers and their audiences. Enabling content marketing and monetization for filmmakers provides consumers a space to discover and support beloved films and creators. A versatile solution for individuals and companies in the film industry, Altavod’s implementation demanded the integration of NGXS with a facade structure.",
    ],
    description: "Altavod is a filmmaker-centric platform.",
  },
  {
    imgSrc: cardimg33,
    link: "https://www.movieranker.com",
    logoSrc: cardlogo33,
    rightImg: rightImg33,
    slideImg: slide16,
    title: "Movieranker",
    category: "Entertainment",
    industry: [{ name: "Entertainment/Media", industryImg: entertainment }],
    country: [{ name: "USA", countryImg: usa }],
    services: [
      { name: "Web Development", servicesImg: webDev },
      { name: "Frontend Development", servicesImg: fullStack },
      { name: "UI/UX Design", servicesImg: uiux },
    ],
    technologies: [
      { name: "Angular", technologieImg: angular },
      { name: "Node", technologieImg: node },
      { name: "MongoDB", technologieImg: mongo },
    ],
    paragraphs: [
      "Movie Ranker is our first Angular 2+ project, which was developed by us and incorporates server-side rendering. Initially, it was created in Angular.js and was successfully delivered to the client. After being satisfied with our work, the client hired us to recreate the same project using the latest Angular 2+ version with server-side rendering, leveraging Angular Universal. We also implemented additional features to enhance website performance, such as lazy loading and image lazy loading. Furthermore, we integrated Smartfeed to display personalized feeds from the open web.",
    ],
    description:
      "Movie Ranker is a social media management platform to engage movie enthusiasts.",
  },
  {
    imgSrc: cardimg34,
    link: "https://www.wishyoo.com",
    logoSrc: cardlogo34,
    rightImg: rightImg34,
    slideImg: slide17,
    title: "Wishyoo",
    category: "E-Commerce",
    industry: [
      {
        name: "Greeting Cards and Personalized Gifts",
        industryImg: entertainment,
      },
    ],
    country: [{ name: "USA", countryImg: usa }],
    services: [
      { name: "Web Development", servicesImg: webDev },
      { name: "UI/UX Design", servicesImg: uiux },
    ],
    technologies: [{ name: "React", technologieImg: react }],
    paragraphs: [
      "During our learning journey with D3.js, an exciting opportunity presented itself when a client entrusted us with the Wishyoo project. This project marked the beginning of a collaborative effort to create a unique platform. Initially, the task involved developing a solution that allowed users to craft custom messages with a virtual pen on a digital board. The innovative concept captured the client’s imagination, and we embraced the challenge. As we progressed, we embarked on several improvement projects to refine and expand the platform. Wishyoo is a testament to our ability to adapt, learn, and deliver solutions that push the boundaries of creativity and engagement.",
    ],
    description:
      "Wishyoo's Ecard Handwriting platform empowers users to craft and send personalized e-cards.",
  },
  {
    imgSrc: cardimg35,
    link: "https://algo.monster",
    logoSrc: cardlogo35,
    rightImg: rightImg35,
    slideImg: slide18,
    title: "AlgoMonster",
    category: "Education",
    industry: [{ name: "Education", industryImg: lerning }],
    country: [{ name: "Canada", countryImg: canada }],
    services: [
      { name: "Web Development", servicesImg: webDev },
      { name: "Mobile App Development", servicesImg: appDev },
      { name: "Frontend Development", servicesImg: fullStack },
      { name: "Backend Development", servicesImg: backend },
    ],
    technologies: [
      { name: "React", technologieImg: react },
      { name: "Python", technologieImg: python },
    ],
    paragraphs: [
      "In our collaboration with the client, we embarked on a journey to transform a Figma design into a fully functional website. What began as an evaluation of CSS styling skills soon evolved into a project filled with challenges and innovation. The client was impressed with our performance during the interview, and this trust led to exciting tasks and responsibilities. From working with code reviewer libraries to crafting algorithms and integrating the Stripe payment gateway, we encountered diverse challenges that made this project both engaging and rewarding. One of our notable achievements was the creation of a custom visualization to showcase user progress. AlgoMonster stands as a testament to our adaptability and dedication to delivering exceptional results.",
    ],
    description:
      "AlgoMonster is a platform that empowers individuals to excel in technical interviews.",
  },

  {
    imgSrc: cardimg37,
    link: "https://theparcelport.com",
    logoSrc: cardlogo37,
    rightImg: rightImg37,
    slideImg: slide20,
    title: "ParcelPort",
    category: "Logistics & Shipping",
    industry: [{ name: "Logistic", industryImg: logistic }],
    country: [{ name: "Canada", countryImg: canada }],
    services: [
      { name: "Web Development", servicesImg: webDev },
      { name: "Frontend Development", servicesImg: fullStack },
      { name: "Mobile App Development", servicesImg: appDev },
      { name: "UI/UX Design", servicesImg: uiux },
    ],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    paragraphs: [
      "ParcelPort is the industry leader in providing Smart Locker and logistics solutions for retailers, property managers, consumers, and couriers. We started with the development of a Web portal and based on the marvelous work delivered by our tech team the client entrusted us with creating an interactive Android and hardware communication app to streamline the whole process of parcel pickup and drop-off. In 7 years of our journey, we’ve successfully delivered top-notch service for our client’s out-of-the-box requirements.",
    ],
    description:
      "ParcelPort is a logistic solution and a secure and smart locker.",
  },

  {
    imgSrc: cardimg40,
    link: "https://www.finfolio.com",
    logoSrc: cardlogo40,
    rightImg: rightImg40,
    slideImg: slide23,
    title: "Finfolio",
    category: "Investment",
    industry: [{ name: "Investment", industryImg: invest }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Frontend Development", servicesImg: fullStack }],
    technologies: [{ name: "React", technologieImg: react }],
    paragraphs: [
      "Our client initially engaged us to enhance their wealth management platform’s UI/UX. Our dedication to quality and exceeding expectations led to expanding the project into a comprehensive web application. After a fruitful 4+ years, we’ve integrated significant features, solidifying the platform as a cutting-edge solution. Our advanced system empowers clients with state-of-the-art financial tools, earning positive feedback from users and financial advisors alike. It’s a testament to efficient wealth management, improved decision-making, and unwavering security and compliance standards.",
    ],
    description: "Finfolio is an all-in-one wealth management software.",
  },

  {
    imgSrc: cardimg43,
    link: "https://shiptime.com",
    logoSrc: cardlogo43,
    rightImg: rightImg43,
    slideImg: slide25,
    title: "ShipTime",
    category: "Logistics & Shipping",
    industry: [{ name: "Shipping", industryImg: ecom }],
    country: [{ name: "USA", countryImg: usa }],
    services: [
      { name: "Frontend Development", servicesImg: fullStack },
      { name: "Web Development", servicesImg: webDev },
      { name: "Mobile Development", servicesImg: appDev },
      { name: "UI/UX Design", servicesImg: uiux },
    ],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    paragraphs: [
      "This project started as a UI design partnership, With our constant hard work and diligence with time it has blossomed into full-scale development. Today, Codeffi proudly shoulders all development tasks and deployment, enhancing the ShipTime platform. Together, we’ve transformed shipping with an all-in-one solution, simplifying the process. ShipTime handles packages, envelopes, and even LTL Freight, seamlessly generating the necessary documentation. Our partnership has played a crucial role in shaping this large-scale project, boosting platform traffic through innovative design and continuous updates. Your ongoing support has been instrumental in our success.",
    ],
    description: "ShipTime is a go-to solution for all-rounder shipping.",
  },

  {
    imgSrc: VEYNOUImage,
    link: "https://veynou.com",
    logoSrc: veynouLogo,
    rightImg: VEYNOUImageRight,
    slideImg: veynouSlider,
    title: "Veynou",
    category: "jewellery E-Commerce",
    industry: [{ name: "E-Commerce", industryImg: ecom }],
    country: [{ name: "Germany", countryImg: germony }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "shopify", technologieImg: shopify }],
    description:
      "Veynou is a premium jewellery e-commerce platform offering an elegant collection of modern and timeless jewellery pieces crafted for customers across Europe.",
    paragraphs: [
      "Veynou is a luxury jewellery brand focused on delivering finely crafted jewellery that blends contemporary design with timeless elegance. The platform showcases a curated collection of rings, necklaces, bracelets, and statement pieces designed for modern lifestyles.",
      "Built on Shopify, Veynou provides a seamless and secure shopping experience. Customers can easily browse collections, view high-quality product visuals, make secure payments, and enjoy reliable shipping across Germany and other European regions.",
    ],
    challenges: {
      intro:
        "While developing the Veynou jewellery e-commerce platform, several key challenges were addressed:",
      points: [
        "Designing a 'luxurious and visually appealing interface' that reflects the premium nature of the jewellery brand.",
        "Showcasing jewellery products with 'high-quality imagery and smooth user experience' to build customer trust.",
        "Implementing 'secure payment gateways' suitable for high-value jewellery purchases.",
        "Ensuring 'mobile-first responsiveness' for users shopping across multiple devices.",
        "Optimizing performance and checkout flow to provide a 'fast and seamless shopping experience'.",
      ],
    },
    deliverables: {
      intro:
        "After carefully addressing all project requirements, our team successfully delivered the following solutions:",

      points: [
        "'Front-end development :' A modern, elegant, and fully responsive user interface that reflects the premium identity of the Veynou jewellery brand.",
        "'Back-end development :' A scalable and secure Shopify-powered architecture ensuring smooth product, order, and inventory management.",
        "'Payment integration :' Trusted and secure payment gateways optimized for high-value jewellery transactions.",
        "'Shipping integration :' Reliable shipping solutions with real-time order tracking across Germany and Europe.",
        "'Performance optimization :' Enhanced site speed, SEO optimization, and cross-device compatibility for a seamless shopping experience.",
      ],
    },

    conclusions: {
      info: [
        "The launch of Veynou Jewellery received an excellent response from customers, who praised the platform’s refined design and effortless shopping experience.",
        "Customers appreciated the high-quality product presentation, smooth navigation, and secure checkout process, which helped build confidence in purchasing fine jewellery online.",
        "With a strong digital presence and a scalable Shopify infrastructure, Veynou has successfully positioned itself as a trusted destination for premium jewellery, blending elegance, reliability, and modern e-commerce convenience.",
      ],
    },
  },

  {
    imgSrc: beautifulearthboutique,
    link: "https://beautifulearthboutique.com",
    logoSrc: beautifuLogo,
    rightImg: beautifulRight,
    slideImg: beautifulSlider,
    title: "Beautiful Earth Boutique",
    category: "jewellery E-Commerce",
    industry: [{ name: "E-Commerce", industryImg: ecom }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "shopify", technologieImg: shopify }],
    description:
      "Beautiful Earth Boutique is a sustainable jewellery e-commerce platform offering handcrafted and ethically inspired jewellery pieces designed with natural elegance.",
    paragraphs: [
      "Beautiful Earth Boutique celebrates jewellery that is inspired by nature, craftsmanship, and conscious design. The platform features a thoughtfully curated collection of necklaces, earrings, rings, and bracelets that reflect timeless beauty with a modern, earthy touch.",
      "Powered by Shopify, the website delivers a smooth and secure shopping journey. Customers can explore detailed product pages, view refined imagery, complete safe transactions, and enjoy reliable delivery services across Germany and Europe.",
    ],
    challenges: {
      intro:
        "During the development of the Beautiful Earth Boutique jewellery platform, the following challenges were addressed:",

      points: [
        "Creating a 'clean and nature-inspired design language' that aligns with the brand’s sustainable identity.",
        "Presenting handcrafted jewellery with 'clear visuals and informative product storytelling'.",
        "Building customer trust through 'secure and transparent payment systems'.",
        "Ensuring a 'mobile-friendly and responsive layout' for modern shoppers.",
        "Optimizing website performance to support a 'smooth and distraction-free checkout experience'.",
      ],
    },
    deliverables: {
      intro:
        "To meet the brand vision and business goals, our team delivered the following solutions:",

      points: [
        "'Front-end development :' A minimal, elegant, and responsive interface reflecting the natural and premium feel of the brand.",
        "'Back-end development :' A reliable Shopify-based system for seamless product, order, and inventory management.",
        "'Payment integration :' Secure and flexible payment gateways to support safe jewellery purchases.",
        "'Shipping integration :' Efficient shipping setup with tracking support across European regions.",
        "'Optimization :' Performance, SEO, and cross-device optimization for consistent user experience.",
      ],
    },

    conclusions: {
      info: [
        "The launch of Beautiful Earth Boutique was positively received, with customers appreciating the brand’s calm aesthetic and easy-to-use shopping experience.",
        "Users highlighted the clarity of product information, smooth navigation, and trustworthy checkout process, making online jewellery purchasing effortless.",
        "With a strong Shopify foundation and a refined digital presence, Beautiful Earth Boutique has established itself as a trusted destination for consciously crafted jewellery.",
      ],
    },
  },

  {
    imgSrc: oudDubai,
    link: "https://oudarabiadubai.com",
    logoSrc: oudDubaiLogo,
    rightImg: oudDubaiRight,
    slideImg: oudDubaiSlider,
    title: "Oud Arabia Dubai",
    category: "Perfume & Attar E-Commerce",
    industry: [{ name: "E-Commerce", industryImg: ecom }],
    country: [{ name: "UAE", countryImg: uae }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "shopify", technologieImg: shopify }],
    description:
      "Oud Arabia Dubai is a premium perfume and attar e-commerce platform offering authentic Arabic fragrances crafted with rich, long-lasting notes and luxurious ingredients.",
    paragraphs: [
      "Oud Arabia Dubai specializes in exquisite perfumes and traditional attars inspired by the rich heritage of Middle Eastern perfumery. The collection includes pure oud oils, concentrated attars, and luxury perfumes designed for those who appreciate deep, distinctive, and long-lasting fragrances.",

      "Built on Shopify, the platform delivers a seamless and secure shopping experience. Customers can explore detailed fragrance descriptions, discover scent profiles, make safe payments, and enjoy reliable shipping across the USA and international locations.",
    ],
    challenges: {
      intro:
        "While developing the Oud Arabia Dubai perfume and attar e-commerce platform, several challenges were addressed:",

      points: [
        "Creating a 'luxury and culturally rich visual identity' that reflects Arabic fragrance traditions.",
        "Presenting perfumes and attars with 'clear scent descriptions and premium product presentation'.",
        "Building customer confidence through 'secure payment gateways' for high-value fragrance products.",
        "Ensuring a 'mobile-optimized and responsive experience' for fragrance shoppers on all devices.",
        "Optimizing site speed and checkout flow for a 'smooth and effortless purchasing journey'.",
      ],
    },
    deliverables: {
      intro:
        "To bring the Oud Arabia Dubai brand vision to life, our team delivered the following solutions:",

      points: [
        "'Front-end development :' A refined and elegant interface inspired by luxury Arabic perfumery.",
        "'Back-end development :' A scalable Shopify-based system for smooth product, order, and inventory management.",
        "'Payment integration :' Secure and trusted payment solutions for perfume and attar purchases.",
        "'Shipping integration :' Reliable domestic and international shipping with order tracking support.",
        "'Optimization :' Performance, SEO, and cross-device enhancements for a consistent user experience.",
      ],
    },

    conclusions: {
      info: [
        "The launch of Oud Arabia Dubai received strong positive feedback, with customers appreciating the premium look and feel of the website.",
        "Users valued the detailed fragrance descriptions, easy navigation, and secure checkout process, which made selecting perfumes and attars online simple and trustworthy.",
        "With a robust Shopify foundation and a luxury-focused digital presence, Oud Arabia Dubai has positioned itself as a reliable destination for authentic Arabic perfumes and attars.",
      ],
    },
  },

  {
    imgSrc: PrepDaily,
    link: "https://prepdaily.org",
    logoSrc: PrepDailyLogo,
    rightImg: PrepDailyRight,
    slideImg: PrepDailyFull,
    title: "PrepDaily",
    category: "Health Education & HIV Prevention Platform",
    industry: [{ name: "Healthcare & Education", industryImg: health }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "PrepDaily is an educational healthcare platform dedicated to providing clear, accessible information about PrEP (Pre-Exposure Prophylaxis) and HIV prevention to empower informed health decisions.",

    paragraphs: [
      "PrepDaily serves as a trusted digital resource focused on HIV prevention and PrEP awareness. The platform educates users about how PrEP works, who it is for, and how consistent use can significantly reduce the risk of HIV transmission.",

      "Designed with accessibility and clarity in mind, PrepDaily helps individuals connect with reliable prevention resources, understand testing options, and navigate access to PrEP through healthcare providers and support services.",
    ],

    challenges: {
      intro:
        "While building the PrepDaily health education platform, several key challenges were addressed:",

      points: [
        "Simplifying 'complex medical information' into clear, easy-to-understand educational content.",
        "Building trust through 'accurate, up-to-date, and medically reliable information'.",
        "Designing an 'accessible and inclusive user experience' for diverse audiences.",
        "Ensuring the platform is 'mobile-friendly and easy to navigate' for all users.",
        "Structuring content to effectively guide users toward 'prevention resources and next steps'.",
      ],
    },
    deliverables: {
      intro:
        "To support PrepDaily’s mission of education and prevention, our team delivered the following solutions:",

      points: [
        "'Front-end development :' A clean, readable, and accessible interface focused on clarity and usability.",
        "'Content structure :' Well-organized educational sections covering PrEP, HIV prevention, and FAQs.",
        "'Navigation experience :' User-friendly flows guiding visitors to relevant health resources.",
        "'Responsive design :' Optimized layouts for mobile, tablet, and desktop devices.",
        "'Performance optimization :' Fast load times and accessibility-focused enhancements.",
      ],
    },

    conclusions: {
      info: [
        "The launch of PrepDaily has helped make HIV prevention information more accessible and approachable for a wide audience.",
        "Users appreciated the clear explanations, structured content, and ease of navigating essential PrEP-related resources.",
        "With a strong educational foundation and user-centered design, PrepDaily stands as a reliable platform supporting awareness, prevention, and informed healthcare choices.",
      ],
    },
  },

  {
    imgSrc: muskaRain,
    link: "https://muskokarain.ca",
    logoSrc: muskaRainLogo,
    rightImg: muskaRainRight,
    slideImg: muskaRainFull,
    title: "Muskoka Rain Irrigation & Lighting",
    category: "Irrigation & Landscape Lighting Services",
    industry: [{ name: "Home & Outdoor Services", industryImg: businesServic }],
    country: [{ name: "Canada", countryImg: canada }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "Muskoka Rain Irrigation & Lighting is a trusted local provider of irrigation system installations, landscape lighting solutions, and maintenance services serving residential and commercial properties throughout Muskoka, Ontario.",

    paragraphs: [
      "With over 20 years of experience serving Muskoka residents and cottage owners, Muskoka Rain specializes in designing and installing efficient irrigation systems that keep lawns lush, gardens flourishing, and landscapes thriving throughout the seasons. Their expertise helps homeowners protect and enhance their property investment with reliable water management solutions.",

      "In addition to irrigation work, the company offers customized landscape lighting services that enhance outdoor spaces with both functional lighting and aesthetic appeal. Using professional design and installation techniques, Muskoka Rain brings safe, beautiful illumination to pathways, patios, and garden features, creating inviting outdoor environments day and night.",
    ],

    challenges: {
      intro:
        "While building the Muskoka Rain online presence and service platform, several key challenges were addressed to align with the company’s values and client expectations:",

      points: [
        "Communicating 'over two decades of trusted local experience' clearly to new and returning customers.",
        "Showcasing 'practical yet beautifully designed irrigation and lighting solutions' that appeal to Muskoka homeowners and cottagers.",
        "Providing service information in a way that builds 'customer confidence and trust' before contact or quote requests.",
        "Ensuring the site is 'easy to navigate for different client segments' including residential, commercial, and seasonal properties.",
        "Highlighting 'ongoing maintenance and warranty services' to show long-term value and reliability.",
      ],
    },
    deliverables: {
      intro:
        "To support Muskoka Rain’s business goals and customer service vision, our team delivered the following solutions:",

      points: [
        "'Front-end development :' A clean, professional user interface that reflects the trusted and experienced nature of the brand.",
        "'Service showcase :' Dedicated pages for irrigation design, installation, lighting, and maintenance services to inform visitors effectively.",
        "'Responsive design :' Mobile, tablet, and desktop optimization to ensure visitors can explore services easily from any device.",
        "'Contact & quote systems :' Streamlined contact forms and service request pathways to boost lead generation and customer inquiries.",
        "'Performance optimization :' Fast loading times and easy navigation to improve user engagement across all service pages.",
      ],
    },

    conclusions: {
      info: [
        "Since launching the updated Muskoka Rain website, the company has strengthened its local online presence and clearly communicated its long history of trusted service in the Muskoka area. :contentReference[oaicite:2]{index=2}",
        "Customers now enjoy a clearer understanding of service offerings, what to expect from installation and maintenance, and how to connect with the team for quotes and support. :contentReference[oaicite:3]{index=3}",
        "Through effective design, accessible service information, and a focus on reliability, Muskoka Rain continues to build strong client relationships and remains one of the region’s go-to providers for irrigation and landscape lighting solutions. :contentReference[oaicite:4]{index=4}",
      ],
    },
  },

  {
    imgSrc: muskokaLake,
    link: "https://muskokalakescontracting.ca",
    logoSrc: muskokaLakeLogo,
    rightImg: muskokaLakeRight,
    slideImg: muskokaLakeFullPage,
    title: "Muskoka Lakes Contracting",
    category: "Construction & Contracting Services",
    industry: [
      { name: "Construction & Home Services", industryImg: businesServic },
    ],
    country: [{ name: "Canada", countryImg: canada }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "Muskoka Lakes Contracting is a trusted local contractor based in Bracebridge, Ontario, specializing in custom cottage builds, renovations, timber frame construction, and comprehensive property projects throughout the Muskoka Lakes region.",

    paragraphs: [
      "Founded and operated by experienced contractor Greg Coleman, Muskoka Lakes Contracting has deep roots in the Muskoka area. With a strong understanding of local architectural styles and building requirements, the company offers dependable construction solutions that reflect both tradition and modern craftsmanship.",

      "From consultations and planning to final construction and finishing touches, Muskoka Lakes Contracting handles a wide range of construction needs including site planning, structural work, custom woodworking, finishes, and property enhancements — all delivered with attention to detail and client satisfaction.",
    ],

    challenges: {
      intro:
        "While developing a cohesive online presence and service platform for Muskoka Lakes Contracting, the following challenges were addressed:",

      points: [
        "Effectively communicating the company’s decades of local construction experience and trusted reputation in Bracebridge and surrounding communities. :contentReference[oaicite:2]{index=2}",
        "Showcasing the breadth of services offered, from custom builds to renovations and specialized timber work. :contentReference[oaicite:3]{index=3}",
        "Providing clear project descriptions that help potential clients understand the process and scope of construction work. :contentReference[oaicite:4]{index=4}",
        "Ensuring the website design reflects the professionalism, craftsmanship, and traditional aesthetics valued by Muskoka property owners. :contentReference[oaicite:5]{index=5}",
        "Highlighting customer testimonials that build trust and credibility for new clients. :contentReference[oaicite:6]{index=6}",
      ],
    },
    deliverables: {
      intro:
        "To align with Muskoka Lakes Contracting’s business goals, our team delivered the following solutions:",

      points: [
        "'Front-end development :' A professional, easy-to-navigate website interface that highlights the company’s heritage, services, and completed projects.",
        "'Service showcase :' Structured information about construction offerings including custom builds, renovations, site work, finishes, and more.",
        "'Project presentation :' Gallery and project examples to help visitors envision the quality and style of workmanship.",
        "'Responsive design :' Optimized layout for desktop, tablet, and mobile browsing to ensure accessibility for all users.",
        "'Client trust elements :' Integration of customer testimonials and service descriptions to support credibility and decision-making.",
      ],
    },
    conclusions: {
      info: [
        "The updated Muskoka Lakes Contracting website has strengthened their online visibility and better communicates the company’s expertise and deep local roots in the Muskoka Lakes region. :contentReference[oaicite:7]{index=7}",
        "Clients now have a clearer understanding of the wide range of construction services offered, from custom cottage construction to finishing work and property enhancements. :contentReference[oaicite:8]{index=8}",
        "With a focus on quality, trust, and customer satisfaction, Muskoka Lakes Contracting continues to be a go-to choice for residents and property owners seeking reliable and skilled construction services. :contentReference[oaicite:9]{index=9}",
      ],
    },
  },

  {
    imgSrc: fitnessVita,
    link: "https://myvitafitness.ca",
    logoSrc: fitnessVitaLogo,
    rightImg: fitnessVitaRight,
    slideImg: fitnessVitaFull,
    title: "My Vita Fitness",
    category: "Fitness Training & Wellness Services",
    industry: [{ name: "Health & Fitness", industryImg: fitness }],
    country: [{ name: "Canada", countryImg: canada }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "My Vita Fitness is a community-focused fitness and wellness platform in Bracebridge, Ontario, offering personalized training, group classes, and one-on-one coaching to help clients of all fitness levels reach their goals with confidence and support.",

    paragraphs: [
      "At My Vita Fitness, the focus is on helping individuals build strength, improve wellness, and achieve personal fitness goals through a combination of customized private training and engaging group classes. With a warm and supportive community atmosphere, clients enjoy workouts designed to challenge and motivate while being accessible at every level.",

      "The platform offers a variety of training options including one-on-one sessions, partner coaching, and group classes such as HIIT, Pilates, core strengthening, and weekend outdoor workouts. Each program emphasizes proper technique, measurable progress tracking, and sustained motivation to ensure meaningful results.",
    ],

    challenges: {
      intro:
        "During the development of the My Vita Fitness online presence and program communication, our team tackled several key challenges:",

      points: [
        "Translating the in-person community energy of the gym into an inviting and motivational online experience.",
        "Clearly showcasing the diversity of fitness offerings from private training to dynamic group classes. :contentReference[oaicite:3]{index=3}",
        "Communicating trainer expertise and personalized support that differentiates My Vita Fitness from generic gyms. :contentReference[oaicite:4]{index=4}",
        "Ensuring visitors easily understand how to book sessions, view class schedules, and start their fitness journey.",
        "Highlighting client success stories to build credibility and encourage goal-driven visitors to take action. :contentReference[oaicite:5]{index=5}",
      ],
    },
    deliverables: {
      intro:
        "To support the client’s vision and mission, our team delivered the following impactful solutions:",

      points: [
        "'Front-end design :' An energetic, user-friendly interface that reflects the community spirit and professional nature of My Vita Fitness.",
        "'Service breakdown :' Dedicated sections for personal training, group classes, and fitness education with clear description and imagery.",
        "'Class & booking integration :' Seamless scheduling and class signup flows powered by the MINDBODY system.",
        "'Responsive design :' Fully optimized layout for mobile, tablet, and desktop, enabling easy access for all users.",
        "'Progress tracking :' Framework to communicate goal setting, milestone tracking, and fitness consultations.",
      ],
    },

    conclusions: {
      info: [
        "The refreshed My Vita Fitness content and platform has improved clarity around services offered, making it easier for visitors to understand their options and get started on their fitness journey. :contentReference[oaicite:6]{index=6}",
        "By emphasizing both private training and group experiences, the brand now presents a well-rounded fitness ecosystem that attracts a wider range of clients. :contentReference[oaicite:7]{index=7}",
        "With a focus on results, community, and welcoming environment, My Vita Fitness continues to inspire individuals in Muskoka to stay active, set goals, and achieve transformative wellness milestones. :contentReference[oaicite:8]{index=8}",
      ],
    },
  },

  {
    imgSrc: Pediatric,
    link: "https://kidsdentistforestpark.com",
    logoSrc: PediatricLogo,
    rightImg: PediatricRight,
    slideImg: PediatricFull,
    title: "Kids Dentist Forest Park",
    category: "Pediatric Dental Care & Children’s Dentistry",
    industry: [{ name: "Healthcare & Dentistry", industryImg: fitness }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "Kids Dentist Forest Park (Little Teeth Big Smiles Children’s Dentistry) is a dedicated pediatric dental practice providing specialized, gentle, and fun dental care for infants, children, teens, and patients with unique needs in Forest Park, IL and surrounding communities.",

    paragraphs: [
      "At Kids Dentist Forest Park, the team focuses on delivering high-quality pediatric dental care in a welcoming and child-friendly environment. From the first tooth to adolescence, every aspect of oral health is addressed with personalized attention and compassionate service to ensure children develop healthy, lifelong smiles.",

      "The practice offers a full range of pediatric dental services including preventive care like cleanings, fluoride treatments, and sealants, as well as restorative treatments and comfort-focused procedures for anxious or fearful patients. With experienced, child-focused professionals and state-of-the-art care, the dental experience is tailored to make every visit positive and stress-free. :contentReference[oaicite:2]{index=2}",
    ],

    challenges: {
      intro:
        "While creating an effective web presence for Kids Dentist Forest Park, our team addressed several key goals to reflect the practice’s unique focus on children’s dental care:",

      points: [
        "Communicating the specialized pediatric expertise that distinguishes children’s dental care from general dentistry. :contentReference[oaicite:3]{index=3}",
        "Presenting a welcoming and reassuring tone to help parents feel confident and comfortable before their child’s appointment.",
        "Highlighting the fun, kid-friendly environment that helps ease children’s dental anxiety. :contentReference[oaicite:4]{index=4}",
        "Showcasing a complete range of services from preventive exams to sedation dentistry and first-visit guidance. :contentReference[oaicite:5]{index=5}",
        "Making information about appointments, insurance support, and dental FAQs easy to find and understand.",
      ],
    },
    deliverables: {
      intro:
        "To support the Kids Dentist Forest Park mission and enhance the patient experience online, our team delivered the following solutions:",

      points: [
        "'Front-end design :' A bright, child-friendly website interface reflecting warmth, trust, and professionalism.",
        "'Services showcase :' Clear presentation of pediatric dental care, preventive treatments, sedation options, and first-visit expectations.",
        "'Educational content :' Useful guides such as how to prepare for a first dental visit and child-specific dental FAQs.",
        "'Responsive design :' Optimized for all devices so parents can easily browse and book appointments from mobile or desktop.",
        "'Community trust elements :' Highlighted team profiles and personalized care messaging to build confidence with families.",
      ],
    },

    conclusions: {
      info: [
        "The updated Kids Dentist Forest Park content better communicates the practice’s commitment to gentle, child-focused dental care and builds trust with families seeking quality pediatric dentistry. :contentReference[oaicite:6]{index=6}",
        "Parents now have clear insights into what to expect during their child’s visit, from preventive checkups to special care and sedation dentistry when needed. :contentReference[oaicite:7]{index=7}",
        "By emphasizing expertise, a fun environment, and a range of services tailored for children, the practice reinforces its position as a trusted dental home for children in Forest Park and nearby communities. :contentReference[oaicite:8]{index=8}",
      ],
    },
  },

  {
    imgSrc: NerdCandy,
    link: "https://kidsdentistforestpark.com",
    logoSrc: NerdCandyLogo,
    rightImg: NerdCandyRight,
    slideImg: NerdCandyFull,
    title: "NERDS Candy",
    category: "Fun & Flavored Candy Products",
    industry: [{ name: "Confectionery & Snacks", industryImg: fitness }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "NERDS Candy is a beloved American confectionery brand known for its tiny, tangy, crunchy bite-sized treats available in a wide variety of unique flavors and playful textures. The official site serves as the central hub for product discovery, seasonal offerings, and retailer information.",

    paragraphs: [
      "NERDS Candy has been delighting candy enthusiasts since its launch in 1983 with its signature dual-flavored crunchy pieces. Each box often features two complementary flavors, inviting fans to enjoy contrasting tastes in every handful — from classic grape and strawberry to adventurous watermelon and cherry.",

      "Over the years, NERDS has expanded its product line to include innovative variants like NERDS Gummy Clusters, which blend tangy sugar shells with a chewy gummy center. This playful combination has become a fan favorite and helped propel the brand to new heights in the confectionery market.",
    ],

    challenges: {
      intro:
        "To create a compelling online presence for NERDS Candy that resonates with both long-time fans and new customers, several key challenges were addressed:",

      points: [
        "Translating the brand’s fun, colorful personality into an engaging and easy-to-navigate website experience.",
        "Organizing a wide array of products — from classic flavors to seasonal and specialty variants — in a way that’s intuitive for visitors.",
        "Making it easy for users to find retailers and purchase options, whether in stores or online.",
        "Showcasing the unique playfulness of the NERDS brand while maintaining clear product information.",
        "Ensuring the site supports social engagement and newsletter signup to keep fans connected with new product updates.",
      ],
    },
    deliverables: {
      intro:
        "To bring the NERDS Candy brand to life online, our team delivered the following results:",

      points: [
        "'Front-end design :' A vibrant, colorful, and playful interface that reflects the joyful spirit of NERDS candy.",
        "'Product presentation :' Well-organized product displays highlighting classic NERDS, NERDS Gummy Clusters, and seasonal releases.",
        "'Retailer guidance :' Clear pathways to help visitors locate where to buy their favorite NERDS products.",
        "'Interactive elements :' Newsletter sign-up and social integration to engage fans with updates, promotions, and community moments.",
        "'Mobile optimization :' Fully responsive design to ensure seamless browsing on desktops, tablets, and smartphones.",
      ],
    },

    conclusions: {
      info: [
        "The updated NERDS Candy site effectively captures the brand’s iconic energy and helps fans explore the full world of NERDS products — from crunchy classics to chewy innovations.:contentReference[oaicite:3]{index=3}",
        "By organizing products, flavors, and purchase paths clearly, the site enhances the user experience and encourages repeat visits for seasonal offerings and new releases.:contentReference[oaicite:4]{index=4}",
        "With a strong digital presence aligned to its playful brand heritage, NERDS Candy continues to engage candy lovers of all ages and serve as a fun destination for discovering sweet, sour, and tangy treats.:contentReference[oaicite:5]{index=5}",
      ],
    },
  },

  {
    imgSrc: windowReplace,
    link: "https://www.newmanwindows.com",
    logoSrc: windowReplaceLogo,
    rightImg: windowReplaceRight,
    slideImg: windowReplaceFull,
    title: "Newman Windows & Doors",
    category: "Window & Door Installation",
    industry: [
      { name: "Home Improvement & Construction", industryImg: fitness },
    ],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "Newman Windows & Doors is a trusted home improvement company offering premium window and door products paired with professional installation services in Southern California, helping homeowners enhance energy efficiency, comfort, and home appeal.",

    paragraphs: [
      "Since 1993, Newman Windows & Doors has been delivering quality window and door solutions to homeowners in San Diego and Orange Counties. Over the years, the company has expanded from a small local business to a trusted home improvement provider, combining top-tier products with exceptional customer service and expert craftsmanship.",

      "The company offers a wide range of window styles and materials — including vinyl, wood, aluminum, and fiberglass — as well as high-performance doors designed to improve home security, insulation, and appearance. From free in-home consultations to custom installations and lifetime warranties, Newman focuses on a seamless experience for every customer. :contentReference[oaicite:2]{index=2}",
    ],

    challenges: {
      intro:
        "While establishing a compelling online and service experience for Newman Windows & Doors, the following challenges were addressed:",

      points: [
        "Translating the company’s decades of craftsmanship and local heritage into a clear and engaging online presence that builds homeowner trust. :contentReference[oaicite:3]{index=3}",
        "Showcasing a diverse range of window and door products in a way that helps users compare options and make informed decisions. :contentReference[oaicite:4]{index=4}",
        "Highlighting the professional installation process and lifetime support that differentiates Newman from competitors. :contentReference[oaicite:5]{index=5}",
        "Communicating energy efficiency benefits and customization flexibility across products and styles. :contentReference[oaicite:6]{index=6}",
        "Ensuring easy access to consultations, service scheduling, and warranty information for prospective clients.",
      ],
    },
    deliverables: {
      intro:
        "To support Newman Windows & Doors’ commitment to quality and service excellence, our team delivered the following solutions:",

      points: [
        "'Front-end design :' A clean, trust-building website interface that reflects the professional standards of Newman Windows & Doors.",
        "'Service showcase :' Clear presentation of window, door, and installation services with detailed insights on product options and home impact.",
        "'Consultation pipeline :' Easy paths for scheduling free in-home consultations and service estimates.",
        "'Responsive design :' Optimized for seamless navigation from desktops, tablets, and mobile devices.",
        "'Installation process highlight :' Structured content outlining the Newman Signature Experience from consultation to completion.",
      ],
    },

    conclusions: {
      info: [
        "The Newman Windows & Doors site now effectively communicates the company’s decades-long commitment to quality home improvement and exceptional customer support. :contentReference[oaicite:7]{index=7}",
        "By organizing product and service information clearly, homeowners can confidently explore options and understand the benefits of professional window and door replacement. :contentReference[oaicite:8]{index=8}",
        "With streamlined consultation scheduling and installation insights, Newman Windows & Doors reinforces its position as a trusted provider of energy-efficient home upgrades in Southern California. :contentReference[oaicite:9]{index=9}",
      ],
    },
  },

  {
    imgSrc: Birmingham,
    link: "https://www.adamporterlaw.com",
    logoSrc: BirminghamLogo,
    rightImg: BirminghamRight,
    slideImg: BirminghamFull,
    title: "Adam Porter Law",
    category: "Employment Law & Workers’ Rights Attorney",
    industry: [{ name: "Legal Services & Employment Law", industryImg: law }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "Adam Porter Law is a dedicated employment law practice in Birmingham, Alabama, focused on protecting the rights of workers facing discrimination, harassment, retaliation, unpaid wages, and wrongful termination through personalized legal advocacy and representational excellence.:contentReference[oaicite:0]{index=0}",

    paragraphs: [
      "Led by experienced attorney Adam M. Porter, the firm brings over 30 years of expertise advocating for workers in central and northern Alabama. Porter Law specializes in defending employees’ rights under federal and state employment laws, helping clients seek justice and compensation when their workplaces have violated their legal protections.",

      "The practice handles a range of employment law matters including discrimination based on race, age, gender, religion or disability, workplace harassment, retaliation, wage and hour claims, and unlawful termination. Porter provides free initial consultations and guides clients through every step of their case with personalized service and strategic legal support.:contentReference[oaicite:2]{index=2}",
    ],

    challenges: {
      intro:
        "In building an effective online presence for Adam Porter Law that reflects the firm’s mission and values, several key challenges were addressed:",

      points: [
        "Clearly communicating the firm’s focus on employment law and workers’ rights advocacy to potential clients who may be unfamiliar with legal protections.:contentReference[oaicite:3]{index=3}",
        "Showcasing the breadth of practice areas including discrimination, harassment, retaliation, wage claims, and more to build confidence for employees seeking help.:contentReference[oaicite:4]{index=4}",
        "Emphasizing the firm’s personalized, high-touch service model that limits client volume to provide individualized attention.:contentReference[oaicite:5]{index=5}",
        "Creating trust by highlighting attorney experience, decades of service, and existing professional reputation in the Birmingham legal community.:contentReference[oaicite:6]{index=6}",
        "Ensuring clear pathways for visitors to request consultations and connect with the firm directly for support.:contentReference[oaicite:7]{index=7}",
      ],
    },
    deliverables: {
      intro:
        "To strengthen Adam Porter Law’s digital platform and client engagement capabilities, our team delivered the following solutions:",

      points: [
        "'Front-end design :' A professional, trust-building interface that reflects the firm’s integrity and deep employment law expertise.",
        "'Service breakdown :' Organized pages covering discrimination, harassment, wage claims, FMLA, ADA and other employment law practice areas.:contentReference[oaicite:8]{index=8}",
        "'Consultation access :' Prominent contact forms and free consultation calls to help potential clients easily request legal assessments.:contentReference[oaicite:9]{index=9}",
        "'Responsive design :' Fully responsive layouts optimized for desktop, tablet, and mobile browsing to improve accessibility.",
        "'Attorney profile highlight :' Clear representation of Adam Porter’s experience and decades of legal practice to build credibility.:contentReference[oaicite:10]{index=10}",
      ],
    },

    conclusions: {
      info: [
        "The updated Adam Porter Law website now effectively communicates the firm’s commitment to fighting workplace injustice for employees across Alabama and beyond.:contentReference[oaicite:11]{index=11}",
        "By clearly presenting practice areas and legal protections available, prospective clients are better informed about their rights and how the firm can help.:contentReference[oaicite:12]{index=12}",
        "With accessible consultation options and a trusted attorney profile, Porter Law reinforces its position as a reliable advocate for workers seeking justice and fair treatment in the workplace.:contentReference[oaicite:13]{index=13}",
      ],
    },
  },

  {
    imgSrc: sellPhone,
    link: "https://flipsy.com",
    logoSrc: sellPhoneLogo,
    rightImg: sellPhoneRight,
    slideImg: sellPhoneFull,
    title: "Flipsy",
    category: "Electronic Device Buyback & Price Comparison",
    industry: [{ name: "Tech & E-commerce", industryImg: ecom }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "Flipsy is a leading online comparison platform that helps users discover the best trade-in values for used electronics — including smartphones, tablets, gaming consoles, watches, and more — by connecting sellers with trusted buyback offers.",

    paragraphs: [
      "Flipsy makes it easy to see how much your electronic devices are worth and where to sell them for the most money. The platform screens offers from trusted buyers and shows real-time price comparisons, allowing users to quickly find the highest payout for items such as iPhones, iPads, Android phones, smart watches, laptops, and gaming consoles. :contentReference[oaicite:2]{index=2}",

      "Whether you’re selling to get cash fast or simply comparing buyback offers before trading in an old device, Flipsy supports zero-hassle offers, free shipping on many sales, and fast payments. Their tools also include price alerts and historical value insights to help sellers time their sales for the best return. :contentReference[oaicite:3]{index=3}",
    ],

    challenges: {
      intro:
        "While building Flipsy’s online value comparison platform, several key challenges were addressed:",

      points: [
        "Aggregating pricing data from many different buyback vendors in a way that’s accurate and easy to understand for users. :contentReference[oaicite:4]{index=4}",
        "Helping users quickly find trusted buyers with transparent terms and payouts. :contentReference[oaicite:5]{index=5}",
        "Ensuring that price alerts, history charts, and offer notifications are intuitive and practical for everyday users. :contentReference[oaicite:6]{index=6}",
        "Providing zero-risk guarantees — like free shipping, device data wipe, and price matches — to build seller confidence. :contentReference[oaicite:7]{index=7}",
        "Communicating device value and trade-in offers in simple language so sellers can make informed decisions without confusion. :contentReference[oaicite:8]{index=8}",
      ],
    },
    deliverables: {
      intro:
        "To meet the service goals and enhance the user experience, the Flipsy platform delivers the following solutions:",

      points: [
        "'Price comparison engine :' A real-time tool showing multiple buyback offers on devices to help shoppers maximize return. :contentReference[oaicite:9]{index=9}",
        "'Trust Verified offers :' Listings from reputable e-commerce buyers ensuring safe, secure transactions. :contentReference[oaicite:10]{index=10}",
        "'Best price guarantee :' If you find a better price after selling, Flipsy will match it and beat it by a set amount. :contentReference[oaicite:11]{index=11}",
        "'Price alerts :' Email notifications on offer changes so users can sell when values rise. :contentReference[oaicite:12]{index=12}",
        "'Device value history :' Insight into historical price trends to help users make more informed decisions. :contentReference[oaicite:13]{index=13}",
      ],
    },

    conclusions: {
      info: [
        "Flipsy has helped millions of device sellers find better payouts by simplifying the search for the best buyback offers online. :contentReference[oaicite:14]{index=14}",
        "By comparing offers in one place and presenting trusted buyers, users can save time and often get more money than trading in with carriers or local stores. :contentReference[oaicite:15]{index=15}",
        "The platform continues to expand its tools and guarantees, giving users confidence that they’re selling their electronics safely, efficiently, and for optimal value. :contentReference[oaicite:16]{index=16}",
      ],
    },
  },

  {
    imgSrc: findCare,
    link: "https://senior.one",
    logoSrc: findCareLogo,
    rightImg: findCareRight,
    slideImg: findCareFull,
    title: "Senior.One",
    category: "Senior Care Navigation & Planning Platform",
    industry: [{ name: "Health & Senior Care Services", industryImg: health }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "Senior.One is a comprehensive free senior care navigation platform designed to help older adults and their caregivers find and compare care providers, schedule tours and assessments, and manage personalized care plans all in one place.",

    paragraphs: [
      "Senior.One empowers families and caregivers by providing a centralized platform to search, compare, and connect with senior living communities, care services, and support providers across the entire senior care continuum. Users can filter options based on needs, budget, reviews, and amenities to make informed decisions with confidence. :contentReference[oaicite:0]{index=0}",

      "The platform’s dashboard allows users to save favorite care options, track care decisions, complete advanced directives, manage appointments, and directly communicate with care providers. With tools that organize the complex process of planning care for aging loved ones, Senior.One simplifies what can otherwise be a stressful experience. ",
    ],

    challenges: {
      intro:
        "When developing an effective senior care navigation experience, several key challenges were addressed:",

      points: [
        "Making a vast range of senior care options — from independent living to memory care and home health services — easy to search, compare, and understand. :contentReference[oaicite:2]{index=2}",
        "Providing a user-friendly dashboard where families can organize care plans, track appointments, and store healthcare forms. :contentReference[oaicite:3]{index=3}",
        "Offering mechanisms to connect directly with care providers without middlemen or barriers. :contentReference[oaicite:4]{index=4}",
        "Helping users navigate the emotional and practical complexities of planning long-term care with confidence and clarity. :contentReference[oaicite:5]{index=5}",
        "Supporting clear communication and collaboration among caregivers, family members, and senior care communities. :contentReference[oaicite:6]{index=6}",
      ],
    },
    deliverables: {
      intro:
        "To deliver a complete senior care planning solution, Senior.One provides users with the following features and tools:",

      points: [
        "'Search & Compare Tool :' A comprehensive search engine for senior care providers and living communities that filters by type, budget, and review rating. :contentReference[oaicite:7]{index=7}",
        "'Direct Connection Features :' Options to schedule community tours, request pricing, ask questions, and book care assessments directly from the platform. :contentReference[oaicite:8]{index=8}",
        "'Personalized Dashboard :' A one-stop space where users can save favorites, manage care decisions, and organize care plans. :contentReference[oaicite:9]{index=9}",
        "'Care Planning Support :' Tools to record decisions, fill advanced directives, and plan ahead with confidence. :contentReference[oaicite:10]{index=10}",
        "'Review and Rating Insights :' Access to customer reviews and provider details to help guide informed choices. :contentReference[oaicite:11]{index=11}",
      ],
    },

    conclusions: {
      info: [
        "Senior.One has transformed how families and caregivers navigate the senior care journey by providing a centralized platform where care providers and services can be easily explored, compared, and selected. :contentReference[oaicite:12]{index=12}",
        "Users benefit from organized care plans, direct communication features, and a streamlined process that reduces stress and saves time during important decisions for aging loved ones. :contentReference[oaicite:13]{index=13}",
        "By bringing together tools for search, planning, and connection in one platform, Senior.One supports confident decision-making and helps families find the care solutions that best fit their needs. :contentReference[oaicite:14]{index=14}",
      ],
    },
  },

  {
    imgSrc: Spotlight,
    link: "https://spotlightindy.org",
    logoSrc: SpotlightLogo,
    rightImg: SpotlightRight,
    slideImg: Spotlightfull,
    title: "Spotlight Indy",
    category: "HIV Prevention Fundraising & Performing Arts Event",
    industry: [{ name: "Nonprofit & Community Health", industryImg: health }],
    country: [{ name: "USA", countryImg: usa }],
    services: [{ name: "Web Development", servicesImg: webDev }],
    technologies: [{ name: "wordpress", technologieImg: wordpress }],
    description:
      "Spotlight Indy is the largest HIV prevention arts fundraiser in the Midwest — an annual performing arts event that brings together the Indianapolis community to support The Indiana AIDS Fund and raise critical resources for HIV testing, prevention, and treatment programs throughout the state.",

    paragraphs: [
      "For more than 30 years, Spotlight has united the Indianapolis arts community in a celebration of song, dance, drama, and theater to raise funds and awareness for HIV prevention efforts across Indiana. Performers from local arts organizations donate their time and talent each year to keep attention on HIV testing and support services for those most at risk. :contentReference[oaicite:1]{index=1}",

      "Organized by The Indiana AIDS Fund, a program of The Health Foundation of Greater Indianapolis, Spotlight proceeds help grant resources to nonprofits and agencies that provide community-based HIV services — including prevention, testing, education, and treatment support that might not otherwise receive funding. Donations directly impact lives statewide by helping people at risk stay healthy and connected to life-saving care. :contentReference[oaicite:2]{index=2}",
    ],

    challenges: {
      intro:
        "While creating a digital presence and outreach strategy for Spotlight Indy, the following challenges were addressed:",

      points: [
        "Effectively communicating the mission and legacy of Spotlight as a long-standing source of funding for HIV prevention in Indiana. :contentReference[oaicite:3]{index=3}",
        "Showcasing a diverse array of participating arts groups and performances to reflect community involvement and cultural impact. :contentReference[oaicite:4]{index=4}",
        "Connecting donors, sponsors, and attendees with clear information about how funds are used to support HIV testing and treatment programs. :contentReference[oaicite:5]{index=5}",
        "Ensuring accessible ticketing and donation pathways that maximize participation and contributions. :contentReference[oaicite:6]{index=6}",
        "Highlighting past impact and future goals to build continued support from individuals, businesses, and partner organizations.",
      ],
    },
    deliverables: {
      intro:
        "To support Spotlight Indy’s mission of fundraising for HIV prevention, our team delivered the following solutions:",

      points: [
        "'Event branding & messaging :' Clear visual and narrative elements that communicate Spotlight’s legacy and purpose within the Indianapolis community.",
        "'Performance showcase :' Structured event details including participating arts organizations, performance line-ups, and sponsorship levels.",
        "'Donation integration :' Easy online pathways for supporters to contribute directly to The Indiana AIDS Fund.",
        "'Sponsor visibility :' Highlighted major event sponsors and partners to recognize community support and encourage continued involvement.",
        "'Responsive outreach :' Multi-device accessibility to ensure potential attendees and donors can interact with the platform comfortably on mobile or desktop.",
      ],
    },

    conclusions: {
      info: [
        "Spotlight Indy continues to be a key cultural event that not only celebrates the performing arts but also drives critical funding to HIV prevention and support efforts across Indiana. :contentReference[oaicite:7]{index=7}",
        "By bringing together artists, donors, sponsors, and volunteers, the event helps raise awareness of HIV and breaks down stigma while providing tangible resources for testing and care. :contentReference[oaicite:8]{index=8}",
        "With ongoing community participation and fundraising success, Spotlight Indy plays an essential role in improving public health outcomes for Hoosiers at risk for or living with HIV. :contentReference[oaicite:9]{index=9}",
      ],
    },
  },
];

export default portfolioData;
